module.exports = __webpack_public_path__ + "static/alex_miranda-34ef1c146fed977111be957f78b18157.png";